import React from "react";

export const PaymentPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-2xl overflow-hidden">
        
       {/* Header */}
<div className="bg-gradient-to-r from-orange-500 via-orange-600 to-amber-500 px-8 py-12 text-white">
  <h1 className="text-4xl font-bold mb-3">Payment Policy</h1>
  <p className="text-lg text-orange-100">
    Please review our payment terms and conditions carefully before
    making any transaction.
  </p>
</div>

        {/* Content */}
        <div className="p-8 md:p-12 space-y-10 text-gray-700">

          {/* Introduction */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              1. Introduction
            </h2>
            <p className="leading-7 text-gray-600">
              This Payment Policy outlines the terms and conditions related to
              payments, billing, refunds, and cancellations. By making a
              payment on our platform, you agree to comply with this policy.
            </p>
          </section>

          {/* Accepted Payment Methods */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              2. Accepted Payment Methods
            </h2>
            <p className="mb-4 text-gray-600">
              We accept the following payment methods:
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              {[
                "Credit / Debit Cards",
                "UPI Payments",
                "Net Banking",
                "Wallet Payments",
              ].map((method, index) => (
                <div
                  key={index}
                  className="border rounded-xl p-4 bg-gray-50 hover:shadow-md transition"
                >
                  <p className="font-medium text-gray-800">{method}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Payment Terms */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              3. Payment Terms
            </h2>
            <ul className="list-disc pl-6 space-y-3 text-gray-600">
              <li>All payments must be completed before service activation.</li>
              <li>
                Prices displayed on the website are inclusive/exclusive of
                taxes as applicable.
              </li>
              <li>
                Any failed transaction due to insufficient balance or banking
                issues is the responsibility of the customer.
              </li>
              <li>
                We reserve the right to update pricing without prior notice.
              </li>
            </ul>
          </section>

          {/* Refund Policy */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              4. Refund Policy
            </h2>
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-5">
              <p className="leading-7 text-gray-700">
                Refund requests will be reviewed based on the nature of the
                service purchased. Approved refunds may take{" "}
                <span className="font-semibold text-blue-700">
                  5–7 business days
                </span>{" "}
                to process.
              </p>
            </div>
          </section>

          {/* Cancellation Policy */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              5. Cancellation Policy
            </h2>
            <p className="leading-7 text-gray-600">
              Orders or services may be canceled before processing begins.
              Once the service has started or documents are processed,
              cancellations may not be possible.
            </p>
          </section>

          {/* Security */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              6. Payment Security
            </h2>
            <p className="leading-7 text-gray-600">
              We use secure payment gateways and encryption technologies to
              ensure that your payment details remain safe and protected.
            </p>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              7. Contact Us
            </h2>
            <p className="text-gray-600 leading-7">
              If you have any questions regarding this Payment Policy, please
              contact our support team.
            </p>

            <div className="mt-4 p-5 bg-gray-100 rounded-xl">
              <p>
                <span className="font-semibold">Email:</span>{" "}
                vastukkalp2007gmail.com
              </p>
              <p>
                <span className="font-semibold">Phone:</span> +91  99095 11961
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PaymentPolicy;